// Import der Schriftarten
import '@fontsource-variable/rubik';

// Import der Styles (CSS)
import './styles/main.css';

const menuBtn = document.querySelector('.hamburger');
const siteNav = document.querySelector('#main-nav');

const setMenuState = (isOpen) => {
  menuBtn.setAttribute('aria-expanded', String(isOpen));
  menuBtn.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
  document.body.classList.toggle('nav-open', isOpen);
};

menuBtn.addEventListener('click', () => {
  const isOpen = menuBtn.getAttribute('aria-expanded') === 'true';
  setMenuState(!isOpen);
});

siteNav.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => {
    setMenuState(false);
  });
});
